export default {"src":"https://fishbrain.com/_next/static/media/afternoon.3f7ae2ea.svg","height":44,"width":64,"blurWidth":0,"blurHeight":0};